import moment from 'moment';
// 系統内時間格式統一配置
export const dateFormat = 'dd-MMM-yy';
export const dateMask = '__-___-__';
export const dateTimeFormat = 'dd-MMM-yy hh:mm a';
export const dateTimeMask = '__-___-__ __:__ _M';
export const timeFormat = 'hh:mm a';
export const timeMask = '__:__ _M';
export const dateMomentFormat = (time) => {
  const timeMoment = moment(time);
  if (time && timeMoment.isValid()) {
    return timeMoment.locale('en').format('DD-MMM-YY');
  }
  return '';
};
export const dateTimeMomentFormat = (time) => {
  const timeMoment = moment(time);
  if (time && timeMoment.isValid()) {
    return timeMoment.locale('en').format('DD-MMM-YY hh:mm A');
  }
  return '';
};
export const timeMomentFormat = (time) => {
  const timeMoment = moment(time);
  if (time && timeMoment.isValid()) {
    return timeMoment.locale('en').format('hh:mm A');
  }
  return '';
};
